export default function Problem() {
  const problems = [
    {
      number: '01',
      text: 'Disconnected tools mean double data entry and missed appointments'
    },
    {
      number: '02',
      text: 'Generic software ignores your trade\'s specific needs and workflows'
    },
    {
      number: '03',
      text: 'Paperwork eats 10+ hours weekly that should go to actual work'
    }
  ];

  return (
    <section className="bg-white py-24">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Label */}
        <div className="mb-12">
          <span className="inline-block px-4 py-2 bg-red-50 text-red-600 rounded-full text-xs font-semibold uppercase tracking-wider">
            The Reality
          </span>
        </div>

        {/* Main Heading */}
        <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-16">
          Your tools are working against you
        </h2>

        {/* Problem Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {problems.map((problem, index) => (
            <div key={index} className="relative pl-8 border-l-4 border-red-500">
              {/* Background Number */}
              <div className="absolute top-0 left-8 text-8xl font-extralight text-gray-100 select-none">
                {problem.number}
              </div>
              {/* Problem Text */}
              <div className="relative z-10 pt-4">
                <p className="text-lg text-gray-700 leading-relaxed">
                  {problem.text}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
